import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const RetailerCommandCenterPage = withCompass(
  () => import("../../pages/RetailerCommandCenterPage")
);

export function RebeccaGrayRoutes() {
  return (
    <Switch>
      <Route
        path="/rg/retailer-command-center"
        component={RetailerCommandCenterPage}
      />
    </Switch>
  );
}

export const slug = "rg";
